export enum PrivateParkingModeType {
  View = "view",
  AddPrivateParking = "addPrivateParking",
  EditPrivateParking = "editPrivateParking",
}
